import { z } from "zod";

import { packagingComponentBaseSchema } from "./packaging-component-base";
import { packagingComponentLabelSchema } from "./packaging-component-label";
import { packagingComponentPrintSchema } from "./packaging-component-print";

export const packagingComponentCartonSchema = packagingComponentBaseSchema.extend({
	labels: z.array(packagingComponentLabelSchema),
	prints: z.array(packagingComponentPrintSchema),
});

export type PackagingComponentCarton = z.infer<typeof packagingComponentCartonSchema>;
